import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  link: {
    backgroundColor: "#00000012",
    textDecoration: "none",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
      // backgroundColor: '#00000012'
    },
  },
  sidebarOutlineBtn: {
    width: "100%",
    height: "auto",
    fontSize: "15px",
    border: "1px solid",
    color: theme.palette.text.secondary,
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "column",
    },
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      // backgroundColor: '#00000012'
    },
  },
  externalLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",
  },
  linkActive: {
    backgroundColor: theme.palette.background.light,
  },
  linkNested: {
    paddingLeft: 0,
    "&:hover, &:focus": {
      // backgroundColor: "#FFFFFF",
    },
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary + "99",
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: "",
  },
  linkText: {
    padding: 0,
    color: theme.palette.text.secondary + "CC",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
  },
  linkTextActive: {
    color: theme.palette.text.primary,
  },
  linkTextHidden: {
    opacity: 0,
  },
  //LEFT SIDE SELCTED MENU STYLE
  nestedList: {
    width: "100%",
    paddingTop: "10px",
    paddingLeft: theme.spacing(0),
    // backgroundColor: '#00000012',
    // borderLeft: '8px solid '
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: "#D8D8D880",
  },
}));
